var map = {
	".": 35,
	"./": 35,
	"./GraphQLLanguageService": 97,
	"./GraphQLLanguageService.js": 97,
	"./GraphQLLanguageService.js.flow": 320,
	"./autocompleteUtils": 58,
	"./autocompleteUtils.js": 58,
	"./autocompleteUtils.js.flow": 321,
	"./getAutocompleteSuggestions": 59,
	"./getAutocompleteSuggestions.js": 59,
	"./getAutocompleteSuggestions.js.flow": 322,
	"./getDefinition": 60,
	"./getDefinition.js": 60,
	"./getDefinition.js.flow": 323,
	"./getDiagnostics": 62,
	"./getDiagnostics.js": 62,
	"./getDiagnostics.js.flow": 324,
	"./getOutline": 96,
	"./getOutline.js": 96,
	"./getOutline.js.flow": 325,
	"./index": 35,
	"./index.js": 35,
	"./index.js.flow": 326
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-language-service-interface/dist ^.*$
// module id = 173
// module chunks = 0